import { useState } from 'react';
import Modal from '../../../components/molecules/Modal/Modal';
import toast from 'react-hot-toast';
import { RootState } from '../../../redux/store';
import { useSelector } from 'react-redux';
import { submitSupportIssue } from '../../../services/user-interaction.service';
import PrimaryButton from '../../../components/atoms/Button';


const ModalPaymentInstallments = ({
	open,
	onClose,
	fetchSupportIssues,
}: {
	open: boolean;
	onClose: () => void;
	fetchSupportIssues: () => Promise<void>;
}) => {
	const userProfile = useSelector((state: RootState) => state?.profile?.user);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [paymentInstallments, setPaymentInstallments] = useState<
		'one_payment' | 'max_installments' | ''
	>('');

	const handleSubmit = async () => {
		const body = {
			user_id: userProfile?.id,
			category_type: 'payment_installments_annual_declaration',
			category_detail: 'payment_installments',
			message: paymentInstallments,
			escalation_type: 'config_annual_declaration',
		};
		try {
			if (!userProfile?.id) return;
			setIsLoading(true);
			await submitSupportIssue(body);
			await fetchSupportIssues();
			onClose();
			toast.success('Solicitud enviada correctamente');
		} catch (e) {
			toast.error('Ocurrió un error al enviar la solicitud');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Modal
			open={open}
			onClose={onClose}
			sx='overflow-y-auto w-[90%] max-h-[calc(100dvh-32px)] md:max-h-[calc(100dvh-100px)] max-w-[500px] !p-3'
		>
			<div className='flex flex-col gap-4'>
				<p className='font-bold'>Cuotas en caso de saldo a pagar</p>
				<hr />
				<div className='text-sm flex flex-col gap-2'>
					<p>
						En caso de tener saldo a pagar, puedes elegir pagar en una sola
						cuota o pagar en el máximo de cuotas posibles.
					</p>

					<select
						value={paymentInstallments || ''}
						name='paymentInstallments'
						id='paymentInstallments'
						className='p-2 border border-h-neutral-90 rounded-lg outline-none'
						onChange={(e) =>
							setPaymentInstallments(
								e.target.value as 'one_payment' | 'max_installments',
							)
						}
					>
						<option value=''>Selecciona una opción</option>
						<option value='one_payment'>Una sola cuota</option>
						<option value='max_installments'>
							El máximo de cuotas posibles
						</option>
					</select>
					{paymentInstallments === 'max_installments' && (
						<p className='bg-gradient-to-tr from-h-primary-90/80 to-h-primary-90/20 rounded-lg border border-h-primary-100 shadow-sm p-2'>
							<span className='font-medium'>
								Es importante que pagues todas las líneas de captura en las
								fechas establecidas por el SAT.
							</span>{' '}
							Si no realizas algún pago a tiempo, el SAT exigirá el total del
							saldo pendiente y aplicará intereses por el atraso.
						</p>
					)}
					<PrimaryButton
						label='Guardar'
						onClick={handleSubmit}
						loading={isLoading}
						disabled={!paymentInstallments}
					/>
				</div>
			</div>
		</Modal>
	);
};

export default ModalPaymentInstallments;
